export default __webpack_public_path__ + "f6f4fa8acc9a53a545a9647f41860eba.svg";